import { EMPTY_STATE_CONFIG } from 'modules/customEvents/constants';
import { INGESTION_POLICIES } from 'modules/customEvents/types';
import { useEffect, useState } from 'react';
import { ALL_TIME } from 'ui/datePicker/helpers';

export type CustomEventsTableEmptyStateProps = {
  ingestionPolicyFilter: INGESTION_POLICIES;
  searchQuery: string;
  startDate: string;
  endDate: string;
  preset: string;
};

export const useCustomEventsTableEmptyState = ({
  ingestionPolicyFilter,
  searchQuery,
  startDate,
  endDate,
  preset,
}: CustomEventsTableEmptyStateProps) => {
  const [config, setConfig] = useState(EMPTY_STATE_CONFIG.default);

  const hasSearchFilter = Boolean(searchQuery);
  const hasDateFilter = Boolean(startDate || endDate || (preset && preset !== ALL_TIME));

  useEffect(() => {
    setConfig(() => {
      if (hasSearchFilter) {
        return EMPTY_STATE_CONFIG.search;
      } else if (hasDateFilter) {
        return EMPTY_STATE_CONFIG.dateRange;
      } else if (ingestionPolicyFilter === INGESTION_POLICIES.DEACTIVATED) {
        return EMPTY_STATE_CONFIG.deactivated;
      } else if (ingestionPolicyFilter === INGESTION_POLICIES.DISCARDED) {
        return EMPTY_STATE_CONFIG.discarded;
      }
      return config;
    });
  }, [ingestionPolicyFilter, searchQuery, startDate, endDate, preset]);

  return config;
};
